import CandidateCard from "./CandidateCard";

export default CandidateCard;
